<template>
  <div class="card shadow-md bg-base-100 rounded-xl w-full">
    <div class="card-body p-4 sm:p-5">
      <h2 class="card-title text-base mb-1">Full Standings</h2>
      <div class="overflow-x-auto">
        <table class="table table-sm w-full">
          <thead>
            <tr class="text-xs text-base-content/40 uppercase tracking-wide border-b border-base-content/10">
              <th class="w-8 font-medium pl-0">#</th>
              <th class="w-10 font-medium"></th>
              <th class="font-medium">Player</th>
              <th class="font-medium hidden sm:table-cell">Portfolio</th>
              <th class="font-medium text-right">Return</th>
              <th class="font-medium text-right hidden sm:table-cell">Avg / day</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in rows" :key="row.type === 'gap' ? 'gap' : row.display_name">
              <tr
                v-if="row.type === 'gap'"
                class="cursor-pointer group"
                @click="$emit('expand')"
              >
                <td colspan="6" class="py-1.5 px-0">
                  <div class="flex items-center gap-2">
                    <div class="flex-1 border-t border-dashed border-base-content/15"></div>
                    <span class="flex items-center gap-1 text-xs text-base-content/30 group-hover:text-primary transition-colors duration-150">
                      <i class="mdi mdi-chevron-down text-sm"></i>
                      {{ row.count }} more players
                    </span>
                    <div class="flex-1 border-t border-dashed border-base-content/15"></div>
                  </div>
                </td>
              </tr>
              <tr
                v-else
                class="border-b border-base-content/5 last:border-0 transition-colors duration-100"
                :class="[
                  row.is_me
                    ? 'bg-primary/8 hover:bg-primary/12'
                    : row.rank === 1 ? 'bg-yellow-400/8 hover:bg-base-content/5'
                    : row.rank === 2 ? 'bg-gray-300/8 hover:bg-base-content/5'
                    : row.rank === 3 ? 'bg-orange-400/8 hover:bg-base-content/5'
                    : 'hover:bg-base-content/5',
                ]"
              >
                <td class="pl-0 w-8">
                  <div class="flex items-center justify-center w-5">
                    <i v-if="row.rank === 1" class="mdi mdi-trophy text-warning text-base"></i>
                    <span v-else class="text-sm font-bold" :class="row.is_me ? 'text-primary/70' : 'text-base-content/50'">{{ row.rank }}</span>
                  </div>
                </td>
                <td class="w-10 px-0">
                  <MoverBadge :change="row.position_change ?? 0" />
                </td>
                <td>
                  <span class="font-semibold text-sm" :class="row.is_me ? 'text-primary' : ''">
                    {{ row.display_name }}
                  </span>
                </td>
                <td class="hidden sm:table-cell">
                  <span class="text-xs text-base-content/50">{{ portfolioSummary(row) }}</span>
                </td>
                <td class="text-right">
                  <span class="font-mono font-semibold text-sm" :class="row.total_return >= 0 ? 'text-success' : 'text-error'">
                    {{ row.total_return >= 0 ? '+' : '' }}{{ row.total_return.toFixed(1) }}%
                  </span>
                </td>
                <td class="text-right hidden sm:table-cell">
                  <span class="font-mono text-xs text-base-content/50">
                    {{ row.daily_avg_return >= 0 ? '+' : '' }}{{ row.daily_avg_return.toFixed(2) }}%
                  </span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import MoverBadge from './MoverBadge.vue'
import { portfolioSummary } from '../lib/competitionUtils.js'

defineProps({
  rows: { type: Array, required: true },
})

defineEmits(['expand'])
</script>
